import { supabase } from './supabase';

export interface SellerProfile {
  user_id: string;
  display_name: string;
  avatar_url: string | null;
  member_since: string;
  active_listing_count: number;
  sold_count: number;
  avg_rating: number;
  review_count: number;
  response_rate: number | null; // 0..1, null when < 3 threads
}

/** PII-safe public seller trust profile (SECURITY DEFINER RPC). */
export async function getSellerProfile(userId: string): Promise<SellerProfile | null> {
  try {
    const { data, error } = await supabase.rpc('get_seller_profile', { p_user_id: userId });
    if (error) throw error;
    const row = Array.isArray(data) ? data[0] : data;
    if (!row) return null;
    return {
      ...row,
      active_listing_count: Number(row.active_listing_count) || 0,
      sold_count: Number(row.sold_count) || 0,
      avg_rating: Number(row.avg_rating) || 0,
      review_count: Number(row.review_count) || 0,
      response_rate: row.response_rate == null ? null : Number(row.response_rate),
    } as SellerProfile;
  } catch (e) {
    console.error('getSellerProfile error:', e);
    return null;
  }
}

export function memberSinceLabel(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
}

export function responseRateLabel(rate: number | null): string | null {
  if (rate == null) return null;
  return `Responds to ${Math.round(rate * 100)}% of messages`;
}
